import {useSpinnerStatusContext} from "components/src/hook/UseSpinnerStatusContext";
import {RefreshDouble as Reload} from "iconoir-react";
import Spinner from "react-bootstrap/Spinner";

export type OnClickReload = () => void;

interface ReloadButtonProps {
    onClickReload?: OnClickReload;
}

export const ReloadButton = ({ onClickReload }: ReloadButtonProps) => {
    const { spinnerStateCounter } = useSpinnerStatusContext();

    return (
        <span className="btn-reload">
            {spinnerStateCounter > 0 && (
                <Spinner size="sm" animation="border" variant="primary" />
            )}
            {spinnerStateCounter === 0 && (
                <Reload className={`${(onClickReload === undefined) ? "text-secondary" : "text-success"}`} onClick={onClickReload} strokeWidth={2} />
            )}
        </span>
    );
};
